import CreativePhotographyImg from './img/Creative Photography Studio Scene 2.png'
import jakob from './img/jakob.png' // для курса актерское мастерство
import ArrowRight from './img/Right Arrow.png' // стрелка в право
import Shadow from './img/тень.png' // тень для спискакурсов
import Finygin from './img/Финягин.jpg' // куратор Финягин
import ScreenwritingSkills from './img/основы сценарного.png' // для курса сценарное мастерство
import ScreenwritingSkillsTop from './img/screenwriting-skills.png'
import ScreenwritingSkillsBot from './img/screenwriting-skills2.png'
import Sherbinin from './img/щербинин.jpg' //куратор Щербинин
import HistoryFilm from './img/Истори кино.png' // для курсов история кино
import HistoryFilmTop from './img/histori films.png'
import HistoryFilmBot from './img/histori-films2.png'
import Groznov from './img/Groznov.jpg' // Куратор Грознов
import CinemaClub from './img/киноклуб.png'
import CinemaClubTop from './img/Cinema-club1.png'
import CinemaClubBot from './img/Cinema-club.png'
import Balaikina from './img/Балайкина.jpg'
import Novikova from './img/Новикова.jpg'
import MovieGenresBot from './img/movie-genres.png'
import MovieGenresTop from './img/movie-genres2.png'
import MovieGenres from './img/Nostalgic 3D Cinema Experience, circa 1950s 1.png'
import CreatingAScreenplay from './img/Creative Collaboration in Design Studio 1.png'
import CreatingAScreenplayTop from './img/screenplays2.png'
import CreatingAScreenplayBot from './img/Man_Woman.png'
import Vinogradov from './img/Виноградов.jpg'
import Tomyk from './img/Томяк.jpg'

import DialoguesComedyTop from './img/dialogues-in-comedyPRO.png'
import DialoguesComedyBot from './img/dialogues-in-comedy1.png'

import CommercialVideo from './img/главная произв-во видео.png'
import CommercialVideoTop from './img/произв-во видео на страницу курса.png'
import CommercialVideoBot from './img/производство.png'
import DirectorsWork from './img/главная работа режиссера с актером.png'
import DialoguesInComedy from './img/главная на диалоги в комедии.png'

import DirectorsWorkTop from './img/работа-режиссера.png'
import DirectorsWorkBot from './img/работа-режиссера2.png'

import DocumentaryFilm from './img/док кино.png'
import DocumentaryFilmTop from './img/док кино2 1.png'
import DocumentaryFilmBot from './img/доккино3.png'
import Ustinova from './img/Устинова.png'

import Clip from './img/клип.png'
import Orator from './img/ораторское 4.png'

export default {
  projectList: [
    //Диалоги в комедии март 2025
    {
      slug: 'Dialoguesincomedy',
      name: "ДИАЛОГИ<br> В <span class='yellow-span '>КОМЕДИИ</span> ",
      txt: 'info',
      src: DialoguesInComedy,
      alt: 'Диалоги в комедии',
      nameTutor: 'МАКСИМ ТОМЯК',
      courseInfo: [
        {
          name: ' Максим Томяк',
          value: '15-20 студентов',
          term: 'Срок обучения:',
          hourse: '24',
          deadlines: '4 месяца',
          start: 'весна  2025',
          set: 'Набор курса:',
          set1: 'Открыт',
          pricing: 'Стоимость курса:',
          price: '220 000 руб.',
          print: '/',
          priceoff: '250 000руб.',
          shape: 'Формат обучения:',
          info: 'Онлайн и оффлайн',
          exam: 'Вступительные экзамены:',
          interview: 'Собеседование',
          helpTutor: 'Поддержка тьютора',
          certificate: 'После прохождения курса выдается сертификат',
          percent: 'Действует при 100% оплате',
        },
      ],
      bgHeader: DialoguesComedyTop,
      bg: DialoguesComedyBot,
      bgCourse: Shadow,
      tutorInfo: [
        {
          text: 'Максим Томяк — сценарист, профессионал с&nbsp;многолетним опытом работы в&nbsp;теле- и&nbsp;киноиндустрии. Выпускник&nbsp;юридического факультета Московского университета им.&nbsp;С.&nbsp;Ю.&nbsp;Витте.<br/> Карьера  в Comedy Club Production началась с&nbsp;работы над&nbsp;такими популярными проектами, как&nbsp;«Интерны», «Универ», «СашаТаня» и&nbsp;«Девушки&nbsp;с&nbsp;Макаровым».<br/> Максим развил свой уникальный стиль и&nbsp;подход к&nbsp;созданию комедийного контента, прекрасно понимает специфику работы с&nbsp;актёрами и&nbsp;творческими командами, что&nbsp;делает его востребованным профессионалом в&nbsp;сфере телевидения и&nbsp;кино.',
          quote:
            '«В книгах, лекциях и других источниках незаслуженно мало внимания уделяется написанию правильных и&nbsp;интересных диалогов. Большинство&nbsp;сценаристов учатся писать их&nbsp;интуитивно, и&nbsp;только спустя годы их&nbsp;персонажи начинают звучать уникально и жизненно, а&nbsp;сцены превращаются в&nbsp;полноценные произведения. Я&nbsp;сам прошёл этот путь, и&nbsp;обучая молодых сценаристов, смог сформулировать правила, которые значительно сокращают этот процесс. До&nbsp;сих пор я не&nbsp;нашёл ничего подобного в&nbsp;других источниках.»<br/>«Первые три сцены закладывают фундамент для&nbsp;всей серии или фильма и&nbsp;часто это&nbsp;самые тяжёлые сцены с&nbsp;точки зрения функциональной нагрузки. Однако&nbsp;зрители не&nbsp;любят, когда их перегружают экспозицией, поэтому нужно применить весь свой талант и&nbsp;опыт, чтобы сделать эти&nbsp;начальные сцены легкими, филигранно обернув смысл в&nbsp;юмор, экшн или другие аттракционы.»   <br> «Аттракцион — это привлекательная обертка, в&nbsp;которую завернут смысл сцены.Опытный сценарист выберет тот аттракцион, который сделает разговор максимально лаконичным и&nbsp;острым. Иногда&nbsp;аттракционом может стать мяч в&nbsp;руке героя, если этот мяч влияет на&nbsp;диалог и&nbsp;поворачивает его в&nbsp;нужное русло».',
          imgTutor: Tomyk,
        },
      ],
      quotes:
        'будь в фокусе кино! Мы&nbspнаучим&nbspтебя&nbspсоздавать диалоги, которые заставят зрителей смеяться и&nbsp;запоминать каждую реплику',
      quotesTitle: "<span class='yellow-span'>FREE SUN FILM SCHOOL</span> —",
      data: " Курс предлагает <span class='yellow-span'>уникальную методику</span> написания диалогов для&nbsp;комедий, которая сокращает путь к&nbsp;созданию правдоподобных, живых и&nbsp;смешных сцен. Особое&nbsp;внимание&nbsp;уделяется <span class='yellow-span'>принципам</span>, которые редко раскрываются в&nbsp;других источниках, а&nbsp;также <span class='yellow-span'>важным аспектам</span>  работы с&nbsp;поэпизодниками и&nbsp;сценарной структурой комедии</span>.",
      dream: [
        {
          textTitle: 'ТВОИ ДИАЛОГИ',
          text1:
            " звучат плоско, персонажи неотличимы друг от&nbsp;друга, а&nbsp;шутки не&nbsp;вызывают смех? Этот&nbsp;курс&nbsp;даст тебе <span class='yellow-span '>четкие инструменты</span>, чтобы&nbsp;оживлять сцены и&nbsp;превращать диалоги в&nbsp;мощное <span class='yellow-span '>оружие&nbsp;юмора</span>.  ",
          text2:
            " Дать сценаристам, как начинающим, так и&nbsp;опытным, практические <span class='yellow-span '>знания и&nbsp;инструменты</span> для&nbsp;написания эффективных комедийных диалогов. Научить&nbsp;<span class='yellow-span '>создавать</span> динамичные сцены, <span class='yellow-span '>управлять</span> функцией диалога и&nbsp;работать с&nbsp;поэпизодниками, чтобы усилить драматургию комедийных проектов.",
        },
      ],
      learnListTop: [
        {
          text: 'Как создавать уникальные и&nbsp;правдоподобные диалоги для&nbsp;комедийных персонажей',
          image: ArrowRight,
        },
        {
          text: 'Основные приемы юмора ',
          image: ArrowRight,
        },
        {
          text: 'Как избегать ошибок в&nbsp;комедийных сценариях',
          image: ArrowRight,
        },
      ],
      learnListTop2: [
        {
          text: 'Значение первых сцен и&nbsp;как они задают тон всему произведению',
          image: ArrowRight,
        },
        {
          text: 'Как использовать аттракционы и&nbsp;поэпизодники для&nbsp;усиления сцен',
          image: ArrowRight,
        },
        {
          text: 'Способы экономии времени и&nbsp;ресурсов через эффективное написание диалогов',
          image: ArrowRight,
        },
      ],
      learnListBot: [
        {
          text: 'Практические навыки написания диалогов, которые делают сцены живыми и&nbsp;динамичными',
          image: ArrowRight,
        },
        {
          text: 'Умение структурировать сцены и&nbsp;управлять их функцией',
          image: ArrowRight,
        },
        {
          text: 'Понимание работы с&nbsp;поэпизодниками и&nbsp;как&nbsp;правильно их интерпретировать',
          image: ArrowRight,
        },
      ],
      learnListBot2: [
        {
          text: 'Готовое портфолио с&nbsp;творческими заданиями ',
          image: ArrowRight,
        },
        {
          text: 'Индивидуальные консультации и&nbsp;менторинг от&nbsp;мастера курса',
          image: ArrowRight,
        },
        {
          text: 'Возможность участия в&nbsp;проектах FREE&nbsp;SUN&nbsp;PRODUCTION&nbsp;- “ЗОЛОТОЙ&nbsp;БОНУС”',
          image: ArrowRight,
        },
      ],

      schemeList: [
        {
          title: '1. Введение',
          points: [
            '• Знакомство с преподавателем и участниками курса',
            '• Оценка опыта студентов: начинающие сценаристы или те, кто уже работал с комедийным жанром',
            '• Обсуждение целей и структуры курса, ключевых тем и ожидаемых результатов',
            '• Определение задач и путей дальнейшего обучения',
          ],
        },
        {
          title: '2. Язык персонажей в диалогах',
          points: [
            '• Понятие «язык персонажей» в сценарии',
            '• Как отличить литературные реплики от разговорных',
            '• Основные ошибки в диалогах: академичность и неестественность речи',
            '• Правило «как точно нельзя»: обучение построению жизненных диалогов',
            '• Создание правдоподобных диалогов через точную передачу характера персонажей',
          ],
        },
        {
          title: '3. Юмор в диалогах',
          points: [
            '• Комедийные приемы в сценариях: структурные элементы и схемы',
            '• Как избегать избыточной сложности и витиеватости в комедийных сценах',
            '• Понятие «зашученной сцены» и как её избежать. Что такое «полуюмор»',
            '• Основные инструменты сценариста: ирония и сарказм',
            '• Разбор «репризного юмора», шуток «первого этажа» и «шуток-версий»',
          ],
        },
        {
          title: '4. Первые три сцены',
          points: [
            '• Важность первых трех сцен в комедийном сериале или фильме',
            '• Как настроить основные сюжетные линии и задать жанровые ожидания',
            '• Почему неправильно написанные первые сцены могут снизить восприятие всей работы',
          ],
        },
        {
          title: '5. Функция сцены',
          points: [
            '• Определение функции сцены и её драматической нагрузки перед началом написания',
            '• Различие подходов к написанию сложных и простых сцен',
            '• Управление объемом сцены и ее оптимальная длина',
            '• Построение структуры сцены («скелета») и фокус на драматической функции без избыточного текста',
          ],
        },
        {
          title: '6. Аттракцион в сцене',
          points: [
            '• Понятие «аттракцион» в сцене: что это и как его использовать',
            '• Примеры эффективного использования аттракциона для усиления сцены',
            '• Как определить, когда аттракцион необходим, а когда он избыточен',
          ],
        },
        {
          title: '7. Работа с поэпизодником',
          points: [
            '• Значение поэпизодного плана в комедийных сериалах',
            '• Принципы работы с поэпизодником при написании диалогов',
            '• Как правильно читать поэпизодник и следовать ключевым сюжетным указаниям',
            '• В каких случаях можно отклоняться от поэпизодника, а в каких — нет',
          ],
        },
        {
          title: '8. Как это будут снимать?',
          points: [
            '• Важность понимания съемочного процесса при написании сценария',
            '• Экономика сцены: учёт локаций и затрат при создании диалогов',
            '• Как избежать чрезмерного усложнения мизансцен и сохранить функциональность диалога',
            '• Учёт актёрского бэкграунда и проговаривание реплик вслух для проверки звучания',
            '• Почему эпизодическим актёрам лучше не давать сложные реплики',
          ],
        },
        {
          title: '9. Кинотекст и мизансцена',
          points: [
            '• Роль кинотекста и мизансцены в комедийном жанре',
            '• Почему текст должен быть максимально сжатым и информативным',
            '• Использование сленга и настроенческих формулировок',
            '• Описание мизансцен и их связь с режиссерскими задачами',
            '• Как оптимизация текста помогает сократить хронометраж сцены',
          ],
        },
        {
          title: '10. Работа с правками',
          points: [
            '• Разбор черновых вариантов творческих заданий и общие ошибки',
            '• Правила первого драфта: когда критика уместна, а когда нужно уступить',
            '• Понятие «вкусовщина» и как с ней работать',
            '• Умение учитывать цензуру, текущие повестки и запросы заказчика',
            '• Как выстраивать деловую переписку с продюсерами и заказчиками',
          ],
        },
        {
          title: '11. Материальная часть',
          points: [
            '• Как сценарий становится рабочим документом для съёмочной группы',
            '• Подсчет объема текста: количество знаков и его соответствие хронометражу',
            '• Программы для написания сценариев: советы и секреты',
            '• Использование нейросетей и вспомогательных онлайн-инструментов в работе сценариста',
          ],
        },
        {
          title: '12. Прощание',
          points: [
            '• Подведение итогов курса и анализ роста каждого студента',
            '• Обсуждение рынка сценаристов: сколько стоит сценарий на разных уровнях',
            '• Как выбрать правильные проекты и избегать ненадежных предложений',
            '• Обсуждение дипломных работ',
            '• Вручение дипломов',
          ],
        },
      ],
    },

    //Работа режиссера с актером “Правила игры”
    {
      slug: 'thedirectorsworkwiththeactorrulesofthegame',
      name: "РАБОТА РЕЖИССЕРА С АКТЕРОМ <br><span class='yellow-span '>ПРАВИЛА ИГРЫ</span> ",
      txt: 'info',
      src: DirectorsWork,
      alt: 'Работа режиссера с актером “Правила игры”',
      nameTutor: 'ВЛАДИМИР ВИНОГРАДОВ',
      courseInfo: [
        {
          name: ' Владимир Виноградов',
          value: '15-20 студентов',
          hourse: '24',
          term: 'Срок обучения:',
          deadlines: '4 месяца',
          start: 'весна  2025',
          set: 'Набор курса:',
          set1: 'Открыт',
          price: '150 000 руб.',
          print: '/',
          priceoff: '170 000руб.',
          pricing: 'Стоимость курса:',
          shape: 'Формат обучения:',
          info: 'онлайн и оффлайн',
          generated: 'Курс создан для режиссеров и актеров',
          exam: 'Вступительные экзамены:',
          interview: 'собеседование',
          helpTutor: 'Поддержка тьютора',
          certificate: 'После прохождения курса выдается сертификат',
        },
      ],
      bgHeader: DirectorsWorkTop,
      bg: DirectorsWorkBot,
      bgCourse: Shadow,
      tutorInfo: [
        {
          text: 'Владимир Виноградов -  кинорежиссер и&nbsp;актер кино. Окончил&nbsp;ВГИК&nbsp;- режиссура кино - Мастера Ролан Быков и&nbsp;Владимир&nbsp;Кобрин. </br> 45+ проектов (сериалы, документальные фильмы, тв-шоу, экспериментальное кино и&nbsp;театральные постановки). 10+&nbsp;ролей в&nbsp;кино и&nbsp;сериалах. </br>Работал на&nbsp;СТС, ТВС ,НТВ ,ТВ-6 ,РТР, Первый канал. </br>Премия ТЭФИ - 2002, ТЭФИ - 2009 г. Участник телерынка в&nbsp;Каннах. Сериал&nbsp;“Пенсильвания” лонг-лист “Золотой&nbsp;орел-2017”, лонг-лист “Ника-2017”.',
          quote:
            '«Съемочная площадка — это коллектив, собранный под&nbsp;определенный проект. У&nbsp;меня довольно прямой интерес — выпускать толковых, подготовленных, понимающих профессию режиссеров и&nbsp;актеров».<br> «Смена сериального производства стоит миллионы рублей и&nbsp;от&nbsp;того, как&nbsp;быстро или&nbsp;медленно вы&nbsp;работаете, - продюсеры или&nbsp;кастинг-директора могут принять решение об&nbsp;участии вас в&nbsp;следующих проектах» <br> «Режиссер должен знать, как&nbsp;«работает» актер, находить способы воздействия на&nbsp;актера, искать фишки и&nbsp;лайфхаки, которые приведут актера в&nbsp;нужное для&nbsp;режиссера состояние» <br> «Курс ПРАВИЛА ИГРЫ - это&nbsp;экология кинопроцесса»',
          imgTutor: Vinogradov,
        },
      ],
      quotes:
        'будь в&nbsp;фокусе кино! Секреты&nbspвзаимодействия режиссера и&nbsp;актера на&nbsp;съемочной площадке',
      quotesTitle: "<span class='yellow-span'>FREE SUN FILM SCHOOL</span> —",
      data: " Курс <span class='yellow-span'>«Правила игры»</span> подробно раскрывает особенности работы <span class='yellow-span'>режиссера</span> с&nbsp;<span class='yellow-span'>актером</span> и&nbsp;взаимодействие всех департаментов на&nbsp;съемочной площадке",
      dream: [
        {
          textTitle: 'ПОНИМАЕШЬ ЧТО ',
          text1:
            " актер играет не то что тебе нужно,но не  можешь объяснить задачу? Не знаешь как&nbsp;добиться от&nbsp;актера нужной  <span class='yellow-span '>эмоции в&nbsp;кадре</span>? Ты прошел 250&nbsp;кастингов, но&nbsp;тебя не&nbsp;утвердили ни&nbsp;на одну из&nbsp;<span class='yellow-span '>ролей</span>? Вместе с&nbsp;<span class='yellow-span '>FREE SUN FILM SCHOOL</span> ты научишься искусству взаимодействия режиссера с&nbsp;актером на&nbsp;съемочной площадке ",
          text2:
            " Курс создан для изучения всех <span class='yellow-span '>аспектов работы</span>  режиссера с&nbsp;актером и&nbsp;практического опыта взаимодействия от&nbsp;<span class='yellow-span '>кастинга и&nbsp;кинопроб до&nbsp;продакшена</span>.",
        },
      ],
      learnListTop: [
        {
          text: 'Как устроены все департаменты на&nbsp;съемочной площадке и&nbsp;их взаимодействие',
          image: ArrowRight,
        },
        {
          text: 'Полный процесс работы с&nbsp;актёрами: от&nbsp;кастинга до&nbsp;съёмок',
          image: ArrowRight,
        },
        {
          text: 'Как проводить и&nbsp;проходить кинопробы',
          image: ArrowRight,
        },
      ],
      learnListTop2: [
        {
          text: 'Как формируется съёмочная группа, и&nbsp;каковы ее&nbsp;ключевые задачи на&nbsp;этапе препродакшн',
          image: ArrowRight,
        },
        {
          text: 'Основные документы съемочного процесса: сценарий, вызывной лист, КПП&nbsp;и&nbsp;договоры',
          image: ArrowRight,
        },
        {
          text: 'Этапы постпродакшна и&nbsp;роль режиссёра в&nbsp;этом&nbsp;процессе',
          image: ArrowRight,
        },
      ],
      learnListBot: [
        {
          text: 'Практические навыки проведения и&nbsp;участия в&nbsp;кинопробах',
          image: ArrowRight,
        },
        {
          text: 'Глубокое понимание структуры съемочного процесса и&nbsp;взаимодействия департаментов',
          image: ArrowRight,
        },
        {
          text: 'Навыки работы с актерами на&nbsp;всех этапах производства',
          image: ArrowRight,
        },
      ],
      learnListBot2: [
        {
          text: 'Опыт работы с документацией, необходимой для&nbsp;съемочного процесса',
          image: ArrowRight,
        },
        {
          text: 'Индивидуальные консультации и&nbsp;менторинг от&nbsp;мастера курса',
          image: ArrowRight,
        },
        {
          text: 'Возможность участия в проектах FREE&nbsp;SUN&nbsp;PRODUCTION - “ЗОЛОТОЙ БОНУС”',
          image: ArrowRight,
        },
      ],

      schemeList: [
        {
          title: '1. Вводное занятие',
          points: [
            '• Введение в курс: цели и задачи',
            '• Знакомство с участниками курса',
            '• Обсуждение выполненных вступительных работ',
            '• Описание структуры курса: пред- и постпродакшн, взаимодействие департаментов на съёмочной площадке',
          ],
        },
        {
          title: '2. Структура департаментов в съемочном процессе',
          points: [
            '• Разбор ключевых департаментов',
            '• Взаимодействие департаментов и их подчиненность',
            '• Подводные камни и сложности современного кинопроизводства',
          ],
        },
        {
          title: '3. Путь актера на съемочную площадку',
          points: [
            '• Поиск кастинг-агентства',
            '• Участие в кастингах и визитки',
            '• От кастинга до команды «Мотор!»',
            '• Важные шаги актёра на пути к съёмочной площадке',
          ],
        },
        {
          title: '4. Начало работы над проектом (Pre-production)',
          points: [
            '• Как набирается съёмочная группа: ключевые правила',
            '• Влияние этих правил на судьбу картины',
            '• Основы pre-production',
          ],
        },
        {
          title: '5. Практическое занятие (Оффлайн-встреча)',
          points: [
            '• Умение проводить и проходить кинопробы',
            '• Работа с мастером курса и приглашенным кастинг-директором',
            '• Проведение практических проб',
          ],
        },
        {
          title: '6. Разбор кинопроб',
          points: [
            '• Разбор записанных проб',
            '• Взгляд с двух сторон: точка зрения режиссёра и актёра',
            '• Детальный анализ каждой пробы',
          ],
        },
        {
          title:
            '7. Структура съемочной площадки как производственного процесса',
          points: [
            '• Организация съёмочной площадки',
            '• Работа режиссера  и постановка задач для актёров',
          ],
        },
        {
          title: '8. Документы в съемочном процессе',
          points: [
            '• Важные документы на съёмочной площадке',
            '• Что должен знать каждый участник съёмок об этих документах',
          ],
        },
        {
          title: '9. Постпродакшн',
          points: [
            '• Введение в этапы постпродакшна',
            '• Роль режиссёра и актёра на этапе постпродакшна',
          ],
        },
        {
          title: '10. Поддержание тонуса во время «простоя»',
          points: [
            '• Правила поведения и самоорганизация в период простоев',
            '• Методы аутотренинга для поддержания профессиональной формы',
          ],
        },
        {
          title: '11. Ответы на вопросы по курсу',
          points: [
            '• Обсуждение вопросов, возникших по курсу',
            '• Разбор недостаточно освещенных тем',
            '• Обсуждение результатов практических заданий',
          ],
        },
        {
          title: '12. Итоговое занятие (Оффлайн-встреча)',
          points: [
            '• Презентация дипломных работ',
            '• Просмотр и обсуждение  работ',
            '• Обратная связь от мастера и экспертной комиссии',
            '• Вручение дипломов о прохождении курса',
          ],
        },
      ],
    },
    // курс Киножанры
    {
      slug: 'moviegenres',
      name: "<br><span class='yellow-span '>КИНОЖАНРЫ</span>",
      txt: 'info',
      src: MovieGenres,
      alt: 'Киножанры',
      nameTutor: 'РАДДА НОВИКОВА',
      courseInfo: [
        {
          name: 'Радда Новикова',
          value: '15-20 студентов',
          hourse: '24',
          term: 'Срок обучения:',
          deadlines: '4 месяца',
          start: 'весна 2025',
          set: 'Набор курса:',
          set1: 'Открыт',
          pricing: 'Стоимость курса:',
          price: '110 000 руб.',
          print: '/',
          priceoff: '130 000руб.',
          shape: 'Формат обучения:',
          info: 'онлайн и оффлайн',
          exam: 'Вступительные экзамены:',
          interview: 'собеседование',
          helpTutor: 'Поддержка тьютора',
          certificate: 'После прохождения курса выдается сертификат',
        },
      ],
      bgHeader: MovieGenresTop,
      bg: MovieGenresBot,
      bgCourse: Shadow,
      tutorInfo: [
        {
          text: 'Радда Новикова - режиссер. Выпускница режиссерского факультета ВГИКа им. С.А. Герасимова, с 2004 года работает режиссером-постановщиком. Её работы удостоены многочисленных наград на международных фестивалях, а сериалы для СТС и ТНТ неизменно занимали топовые позиции в рейтингах прайм-тайма.',
          quote:
            '«Жанровое кино — это не просто набор стереотипов. Это язык, на котором мы говорим со зрителем. Мастерство в жанре позволяет нам быть понятными, удивлять и восхищать».',
          imgTutor: Novikova,
        },
      ],
      quotes: '  будь в фокусе кино! Стань&nbsp;королем&nbsp;своего жанра!',
      quotesTitle: "<span class='yellow-span'>FREE SUN FILM SCHOOL</span> —",

      data: "Курс даёт возможность <span class='yellow-span'>детально</span> изучить жанры кино, раскрывая их ключевые принципы и элементы. Каждое занятие включает практические задания и разбор киноклассики, что позволяет не только освоить теорию, но и сразу применить её на практике, создавая собственные <span class='yellow-span'>жанровые проекты</span>",
      dream: [
        {
          textTitle: 'ТВОИ ЖАНРОВЫЕ СЦЕНАРИИ',
          text1:
            "не цепляют, как ты задумал? Хочешь, чтобы зритель не просто смотрел, а замирал на каждом кадре? <span class='yellow-span '>Этот курс</span> — твой шанс перевернуть игру и научиться создавать кино, которое <span class='yellow-span '>останется в памяти</span>. ",
          text2:
            "Дать <span class='yellow-span' >начинающим</span> и <span class='yellow-span' >опытным</span> режиссерам, сценаристам и продюсерам инструменты для полного овладения жанровым кино, чтобы они могли уверенно применять его законы и <span class='yellow-span' >создавать проекты</span> , которые захватывают зрителя.",
        },
      ],
      learnListBot: [
        {
          text: 'Практический опыт работы на съемочной площадке',
          image: ArrowRight,
        },
        {
          text: 'Консультации и менторинг от профессионалов киноиндустрии',
          image: ArrowRight,
        },
      ],
      learnListBot2: [
        {
          text: 'Портфолио с завершенными проектами',
          image: ArrowRight,
        },
        {
          text: 'Уверенность в создании жанровых проектов на высоком уровне',
          image: ArrowRight,
        },
      ],

      learnListTop: [
        {
          text: 'Принципы построения сюжета в различных жанрах',
          image: ArrowRight,
        },
        {
          text: 'Типажи и архетипы персонажей',
          image: ArrowRight,
        },
        {
          text: 'Особенности кастинга для разных жанров',
          image: ArrowRight,
        },
      ],
      learnListTop2: [
        {
          text: 'Работа художника-постановщика и оператора в жанровом кино',
          image: ArrowRight,
        },
        {
          text: 'Использование музыки, грима и костюмов для усиления жанровых элементов',
          image: ArrowRight,
        },
        {
          text: 'Специфика монтажа в зависимости от жанра',
          image: ArrowRight,
        },
      ],
      schemeList: [
        {
          title: '1. Введение',
          points: [
            '• Обзор жанрового кино',
            '• Вертикальное и горизонтальное построение сюжета',
            '• Основные понятия: клиффхэнгер, флешбэк, флэшфорвард, арка персонажа',
            '• Форматы серий и количество сюжетных линий в серии',
          ],
        },
        {
          title: '2. Драма',
          points: [
            '• Психологическая, криминальная, военная, спортивная, социальная, историческая, политическая драма',
          ],
        },
        {
          title: '3. Комедия',
          points: [
            '• Классическая комедия, ситком, драмеди, скетч, чёрная комедия, романтическая комедия (ромком)',
          ],
        },
        {
          title: '4. Триллер',
          points: [
            '• Психологический, мистический, детективный, социальный, политический, эротический триллер',
          ],
        },
        {
          title: '5. ОБоевик',
          points: [
            '• Военный, исторический, криминальный, фантастический, вестерн, комедийный боевик',
          ],
        },
        {
          title: '6. Детектив',
          points: [
            '• Приключенческий, военный, полицейский процедурал, медицинский, иронический, психологический, мистический детектив',
          ],
        },
        {
          title: '7. Мелодрама',
          points: [
            '• Любовная, комедийная, мюзикл, мыльная опера, семейная, производственная мелодрама',
          ],
        },
        {
          title: '8. Хоррор',
          points: [
            '• Слэшер, психологический хоррор, боди-хоррор, мокьюментари, сверхъестественный хоррор, научная фантастика',
          ],
        },
        {
          title: '9. Фэнтези',
          points: [
            '• Детская, современная, тёмная фэнтези, меч и магия, эпическое, комедийное фэнтези',
          ],
        },
        {
          title: '10. Фантастика',
          points: [
            '• Затерянные миры, киберпанк, научная фантастика, стимпанк, антиутопия/постапокалиптика, космическая опера',
          ],
        },
        {
          title: '11. Фильм-катастрофа',
          points: [
            '• Природные катаклизмы, инопланетные вторжения, техногенные катастрофы, эпидемии/зомби, социально-исторические события, научно-популярные фильмы',
          ],
        },
        {
          title: '12. Заключительное занятие',
          points: [
            '• Итоги курса, вопросы-ответы, просмотр и анализ лучших студенческих проектов, обсуждение, вручение дипломов',
          ],
        },
      ],
    },

    // курс Производство коммерческого (рекламного) видео
    {
      slug: 'commercialvideoproduction',
      name: "<span class='yellow-span '>ПРОИЗВОДСТВО</span> КОММЕРЧЕСКОГО <br/>ВИДЕО И РЕКЛАМЫ",
      txt: 'info',
      src: CommercialVideo,
      alt: 'Производство коммерческого видео и рекламы',
      nameTutor: 'АНАСТАСИЯ БАЛАЙКИНА',
      courseInfo: [
        {
          name: 'Анастасия Балайкина',
          value: '15-20 студентов',
          hourse: '24',
          term: 'Срок обучения:',
          deadlines: '4 месяца',
          start: 'весна 2025',
          set: 'Набор курса:',
          set1: 'Открыт',
          pricing: 'Стоимость курса:',
          price: '120 000 руб.',
          print: '/',
          priceoff: '140 000руб.',
          shape: 'Формат обучения:',
          info: 'онлайн и оффлайн',
          exam: 'Вступительные экзамены:',
          interview: 'собеседование',
          helpTutor: 'Поддержка тьютора',
          certificate: 'После прохождения курса выдается сертификат',
        },
      ],
      bgHeader: CommercialVideoTop,
      bg: CommercialVideoBot,
      bgCourse: Shadow,
      tutorInfo: [
        {
          text: 'Анастасия Балакина—продюсер. Окончила  Государственный Университет Управления: Бизнес в строительстве и управление проектом,  Школу драмы Германа Сидакова: Режиссер театра и кино.Член гильдии продюсеров России. <br/>С 2004 года работала в рекламной отрасли, в издательских домах «Афиша», «Ашет Филипаки Шкулев» и «РБК». С 2014 года работала на кино и сериалах в компании «Рекун-синема». На данный момент Генеральный и креативный продюсер в рекламном агентстве «Mosaic», эксперт в креативе и технологиях видеопроизводства. <br/>Имеет многочисленные награды: Effie, Silver Mercury, Tag line, Big fish, Red Apple и другие.. <br/>Член жюри конкурсов: MIXX Russia 2023, Silver Mercury 2024, Путешествуй Больше 2024. <br/>Обширный опыт работы c разными рекламными форматами: музыкальное видео, рекламный короткий метр, CG видео, VR, AR, XR проекты, ТВ видео, OLV видео, манифест, видео с участием селебрити. <br/>Спродюсировала более 400 видео для крупнейших рекламодателей: Сбер, МТС, Pepsico, Reckitt Benkiser, СБП, MasterCard, Durex и других. <br/>Работала со знаменитостями: Оxxymiron, Nilleto, Morgenstern, Natalia Oreiro, Milos Bikovic, Филипп Киркоров, Алексей Щербаков, Сергей Мезенцев, Николай Дроздов, Леонид Агутин, Даня Милохин, Илья Макаров, Дима Билан, Дмитрий Дюжев, Антон Беляев, Дмитрий Маликов, Владимир Сычев.Работала с режиссерами: Илья Найшуллер, Клим Шипенко, Василий Сигарев, Дмитрий Дьяченко,,Олег Трофим, Олексий Соболев, Илья Соловьев.',
          quote:
            '«Этот курс для  креаторов , сценаристов, продюсеров и  режиссеров.В курсе  нет абстрактной теории  которую можно прочитать в интернете или в учебниках  по видеопроизводству. Программа содержит четкую  авторскую  структуру  подхода к видеопроизводству малых форматов, созданной автором на основе своего огромного опыта. Помимо того, что студенты освоят структуру видеопроизводства, которую потом можно перенести и на большие форматы, как кино или сериал, курс содержит разбор огромного количества практических ситуаций, производственных материалов, форм и баз данных, на&nbsp;сбор которых ушли бы годы усердной работы.Можно ли с минимальным бюджетом снять классную рекламу ?Да, если в основе есть цепляющий креатив.».',
          imgTutor: Balaikina,
        },
      ],
      quotes:
        ' будь в фокусе кино! Создавай&nbspрекламные видео, которые продают впечатления!',
      quotesTitle: "<span class='yellow-span'>FREE SUN FILM SCHOOL</span> —",
      data: " Курс разработан <span class='yellow-span'>опытным продюсером</span> с многолетним опытом в международных проектах, включая <span class='yellow-span'>Netflix</span>  и крупные рекламные кампании. Уникальность заключается в сочетании теории и практики: разбор реальных кейсов, работа над живыми проектами и доступ к лучшим практикам индустрии",
      dream: [
        {
          textTitle: 'МЕЧТАЕШЬ СНИМАТЬ ', //боль
          text1:
            "креативную <span class='yellow-span '>рекламу</span> и выигрывать <span class='yellow-span '>тендеры</span> на ее производство? Есть минимальный бюджет,но ты не знаешь как набрать команду под задачи? Наш курс  поможет тебе стать <span class='yellow-span '>профессионалом продюсерского цеха</span>. ", //боль
          text2:
            "Курс направлен на то, чтобы научить <span class='yellow-span '>продюсированию</span> коммерческих видеопроектов от разработки концепции до постпродакшна, с акцентом на работу с командой и управление процессом. Студенты получат навыки <span class='yellow-span '>создания успешных</span> рекламных видео, отвечающих требованиям современного  <span class='yellow-span '>рынка</span>.",
        },
      ],
      learnListTop: [
        {
          text: 'Тренды в рекламе',
          image: ArrowRight,
        },
        {
          text: 'Основы работы продюсера в создании рекламных видео и понимание рекламного рынка',
          image: ArrowRight,
        },
        {
          text: 'Актуальные рекламные форматы, креативные тренды и их влияние на проекты',
          image: ArrowRight,
        },
      ],
      learnListTop2: [
        {
          text: 'Как правильно подбирать режиссера, оператора и творческую команду',
          image: ArrowRight,
        },
        {
          text: 'Особенности бюджетирования и сметы  на разных этапах производства',
          image: ArrowRight,
        },
        {
          text: 'Процесс организации съемочного дня, взаимодействие с командой и постпродакшн',
          image: ArrowRight,
        },
      ],

      learnListBot: [
        {
          text: 'Практический опыт работы над реальными рекламными проектами',
          image: ArrowRight,
        },
        {
          text: 'Умение эффективно управлять процессами съемки и постпродакшна',
          image: ArrowRight,
        },
        {
          text: 'Понимание бюджетирования и защиты бюджета перед клиентом',
          image: ArrowRight,
        },
      ],
      learnListBot2: [
        {
          text: 'Опыт питчинга продюсерской презентации перед заказчиком ',
          image: ArrowRight,
        },
        {
          text: 'Индивидуальные консультации и менторинг от мастера курса',
          image: ArrowRight,
        },
        {
          text: 'Возможность участия в проектах FREE SUN PRODUCTION - “ЗОЛОТОЙ БОНУС”',
          image: ArrowRight,
        },
      ],

      schemeList: [
        {
          title: '1. Вводное',
          points: [
            '• Обзор роли продюсера в создании рекламного видео и структура рекламного рынка в России',
          ],
        },
        {
          title: '2. Рекламные форматы и тренды',
          points: [
            '• Актуальные рекламные форматы, отслеживание трендов и креативные решения в рекламе',
          ],
        },
        {
          title: '3. Выбор режиссёра',
          points: ['• Как правильно подобрать режиссера для проекта'],
        },
        {
          title: '4 - 5. Бюджетирование',
          points: [
            '• Работа с бюджетом: разработка смет, защита бюджета перед клиентом',
          ],
        },
        {
          title: '6. Подбор команды',
          points: [
            '• Формирование творческой и технической команды, понимание профсоюзных ставок, роли каждого специалиста',
          ],
        },
        {
          title: '7. Кастинг и костюмы',
          points: [
            '• Процесс подбора актеров, костюмов и грима, бюджетирование этих элементов',
          ],
        },
        {
          title: '8. Локации и художественное оформление',
          points: [
            '• Выбор локаций, формирование художественных задач, планирование бюджета на арт-департамент',
          ],
        },
        {
          title: '9. Съёмочный процесс',
          points: [
            '• Организация съемочного процесса, управление съёмочной площадкой',
          ],
        },
        {
          title: '10. Постпродакшн',
          points: ['• Этапы постпродакшна, роль продюсера на каждом из них'],
        },
        {
          title: '11. Закрытие проекта',
          points: [
            '• Финальные этапы проекта: мастеринг, технические требования, продвижение на рекламных фестивалях',
          ],
        },
        {
          title: '12. Итоговый экзамен',
          points: [
            '• Презентация дипломной работы, разбор проектов, обратная связь от мастера курса и экспертной комиссии',
          ],
        },
      ],
    },

    //Особенности создания киносценария к жанровому кинофильму
    {
      slug: 'featuresofcreatingascreenplayforagenremovie',
      name: "<span class='yellow-span '>ОСОБЕННОСТИ СОЗДАНИЯ</span> <br/>КИНОСЦЕНАРИЯ<br/> К ЖАНРОВОМУ ФИЛЬМУ",
      txt: 'info',
      src: CreatingAScreenplay,
      alt: 'Особенности создания киносценария к жанровому кинофильму',
      nameTutor: 'АНДРЕЙ ЩЕРБИНИН',
      courseInfo: [
        {
          name: 'Андрей Щербинин',
          value: '15-20 студентов',
          hourse: '24',
          term: 'Срок обучения:',
          deadlines: '4 месяца',
          start: 'весна 2025',
          set: 'Набор курса:',
          set1: 'Открыт',
          pricing: 'Стоимость курса:',
          price: '130 000 руб.',
          print: '/',
          priceoff: '150 000руб.',
          shape: 'Формат обучения:',
          info: 'онлайн',
          exam: 'Вступительные экзамены:',
          interview: 'собеседование',
          helpTutor: 'Поддержка тьютора',
          certificate: 'После прохождения курса выдается сертификат',
        },
      ],
      bgHeader: CreatingAScreenplayTop,
      bg: CreatingAScreenplayBot,
      bgCourse: Shadow,
      tutorInfo: [
        {
          text: 'Андрей Щербинин — драматург и режиссер, выпускник Киргизского государственного института кино и телевидения, а также Высших курсов сценаристов и режиссеров под руководством Петра Тодоровского. В его профессиональном портфолио — более 60 проектов, включая сценарии для сериалов, книг и фильмов, многие из которых удостоены престижных наград. Щербинин обладает опытом во всех ключевых областях кинопроизводства: от написания сценариев до режиссуры и продюсирования.',
          quote:
            '«В жанровом кино есть законы и механизмы.Создавай смешные комедии, трогательные мелодрамы,захватывающие экшены и атмосферные триллеры вместе с нами!»',
          imgTutor: Sherbinin,
        },
      ],
      quotes: ' будь в фокусе кино! Найди&nbspсвой&nbspпочерк!',
      quotesTitle: "<span class='yellow-span'>FREE SUN FILM SCHOOL</span> —",
      data: "Курс разработан для овладения навыком создания <span class='yellow-span'>жанровых историй</span>",
      dream: [
        {
          textTitle: 'ДУМАЕШЬ, ЧТО',
          text1:
            "твоя история – верх юмора,а все слушатели сидят с мрачными лицами?Разберись с <span class='yellow-span '>законами жанров</span> и создай <span class='yellow-span '>свой стиль</span> повествования  вместе с нами  ",
          text2:
            " Подготовить <span class='yellow-span' >начинающих</span> и <span class='yellow-span' >опытных специалистов</span> к созданию успешных жанровых фильмов, которые <span class='yellow-span' >привлекут внимание</span>  широкой аудитории .",
        },
      ],
      learnListTop: [
        {
          text: 'Основы жанрового кино и принципы работы в жанре',
          image: ArrowRight,
        },
        {
          text: 'Отличия авторского и жанрового кино',
          image: ArrowRight,
        },
        {
          text: 'Как разрабатывать  сценарии  для комедии, трагедии и др.',
          image: ArrowRight,
        },
        {
          text: 'Актуальные жанры и их специфику',
          image: ArrowRight,
        },
      ],
      learnListTop2: [
        {
          text: 'Структуру  сценария и создание персонажей с учётом жанра',
          image: ArrowRight,
        },
        {
          text: 'Возможности жанрового смешения',
          image: ArrowRight,
        },
        {
          text: 'Факторы успеха и провала жанровых фильмов',
          image: ArrowRight,
        },
        {
          text: 'Влияние менталитета и массового запроса на жанр',
          image: ArrowRight,
        },
      ],
      learnListBot: [
        {
          text: 'Понимание ключевых принципов создания успешных комедий, трагедий, мелодрам, триллеров  и др.',
          image: ArrowRight,
        },
        {
          text: 'Портфолио с готовыми жанровыми проектами',
          image: ArrowRight,
        },
      ],
      learnListBot2: [
        {
          text: 'Индивидуальные консультации и менторинг от Андрея Щербинина',
          image: ArrowRight,
        },
        {
          text: 'Возможность участия в проектах FREE SUN PRODUCTION - “ЗОЛОТОЙ БОНУС”',
          image: ArrowRight,
        },
      ],

      schemeList: [
        {
          title: '1. Жанровое кино',
          points: ['• Основные жанры и правила работы в рамках жанра'],
        },
        {
          title: '2. Авторское кино vs. жанровое',
          points: ['• Различия, границы и возможности их пересечения'],
        },
        {
          title: '3. Законы жанров: комедия и трагедия',
          points: ['• Основные законы жанров и способы их нарушения'],
        },
        {
          title: '4. Создание сценариев для комедии и трагедии',
          points: ['• Практическая работа над жанровыми сценариями'],
        },
        {
          title: '5. Современные жанры',
          points: ['• Обзор и анализ успешных и провальных жанров'],
        },
        {
          title: '6. Практикум по созданию жанровых сценариев',
          points: ['• Разработка идей и написание сценариев в жанровом кино'],
        },
        {
          title: '7. Герои в жанровом кино',
          points: ['• Типология героев и работа над созданием персонажей'],
        },
        {
          title: '8. Структура сценария в жанровом кино',
          points: ['• Теоретическая база и практическое применение'],
        },
        {
          title: '9. Смешение жанров',
          points: ['• Анализ экспериментов и успешного смешения жанров'],
        },
        {
          title: '10. Успех и провал жанровых фильмов',
          points: [
            '• Факторы влияния: мастерство драматурга и особенности жанра',
          ],
        },
        {
          title: '11. Менталитет и жанр',
          points: [
            '• Работа с культурными и социальными особенностями для создания успешного жанрового продукта',
          ],
        },
        {
          title: '12. Итоговая',
          points: [
            '• Обсуждение дипломных работ',
            '• Обратная связь от мастера курса',
            '• Вручение дипломов',
          ],
        },
      ],
    },
    // исполнительное продюссировани
    //Продюсирование Документальное кино
    {
      slug: 'documentary-film-production',
      name: "ПРОДЮСИРОВАНИЕ  <br><span class='yellow-span '>ДОКУМЕНТАЛЬНОГО КИНО</span> ",
      txt: 'info',
      src: DocumentaryFilm,
      alt: 'Продюсирование документального кино',
      nameTutor: 'АННА УСТИНОВА',
      courseInfo: [
        {
          name: 'Анна Устинова',
          value: '15-20 студентов',
          hourse: '24',
          term: 'Срок обучения:',
          deadlines: '4 месяца',
          start: 'весна  2025',
          set: 'Набор курса:',
          set1: 'Открыт',
          pricing: 'Стоимость курса:',
          price: '120 000 руб.',
          print: '/',
          priceoff: '140 000руб.',
          shape: 'Формат обучения:',
          info: 'онлайн и оффлайн',
          exam: 'Вступительные экзамены:',
          interview: 'собеседование',
          helpTutor: 'Поддержка тьютора',
          certificate: 'После прохождения курса выдается сертификат',
        },
      ],
      bgHeader: DocumentaryFilmTop,
      bg: DocumentaryFilmBot,
      bgCourse: Shadow,
      tutorInfo: [
        {
          text: 'Анна Устинова - продюсер. Выпускница ВГИК, мастерская телевизионного кино Т.Н. Парсадановой. Начинала свой путь в профессии с работы продюсером в дебютных полнометражных фильмах и художественных сериалах. После  проекта про развитие искусственного интеллекта в России начала  работать в жанре документального кино. <br/>Победитель в конкурсе ИРИ с документальным фильмом “Искусство танцевать: балет”, в котором являлась автором идеи и продюсером. <br/>Победитель тендера на производство документального фильма в жанре докуреалити “Бегущий ниндзя” - док. фильм о трейл-раннинге по заказу ООО Джус для телеканала СТС.<br/>Победитель тендера на производство документального сериала в жанре трукрайм “Киберкрайм” - док. сериал о разных видах интернет мошенничества по заказу ООО Джус для телеканала СТС.<br/>Сняла как исполнительный продюсер 2 документальных фильма, 2 документальных сериала, более 20 образовательных документальных проектов. Производитель документального фильма о строительстве ЖК “Красный октябрь” по заказу ООО Уроки легенд для Гута Девелопмент.',
          quote:
            'Главная особенность нашего жанра - это, конечно, люди: как по одну, так&nbsp;и&nbsp;по&nbsp;другую сторону объектива. Участие реальных героев требует от всей команды, от продюсера до механика камеры, умения установить контакт, чтобы&nbsp;создать атмосферу доверия и искренности, иначе эмоций зритель не&nbsp;увидит. Документалистика&nbsp;часто&nbsp;предполагает&nbsp;работу&nbsp;в&nbsp;непредсказуемых условиях. Съемочная группа должна быть готова к импровизации, если события развиваются неожиданным образом прямо во время съемки. Создание&nbsp;документального&nbsp;кино&nbsp;—&nbsp;это поиск баланса между художественной выразительностью, этикой и правдой. Это искусство, способное менять восприятие и вдохновлять зрителей',
          imgTutor: Ustinova,
        },
      ],
      quotes:
        'будь в фокусе кино ! Создавай&nbsp;актуальные документальные проекты',
      quotesTitle: "<span class='yellow-span'>FREE SUN FILM SCHOOL</span> —",
      data: "<span class='yellow-span'>Информация</span>, которую невозможно получить в теории ни в одном ВУЗе: об этом знают только <span class='yellow-span '>практикующие продюсеры</span> после своего личного большого опыта. <br/>Все из “первых уст”: <span class='yellow-span '>реальные кейсы</span> из документальных фильмов, которые прямо сейчас находятся в производстве или завершены недавно.",
      dream: [
        {
          textTitle: "МЕЧТАЕШЬ <span class='yellow-span'>СОЗДАВАТЬ</span>",
          text1:
            " <span class='yellow-span'>документальное кино</span>  и не знаешь с чего начать? Не уверен в&nbsp;своих знаниях? Был опыт работы только в игровом кино? <span class='yellow-span'>Наш курс</span> ответит на все твои вопросы и даст <span class='yellow-span'>практические знания</span>.",
          text2:
            " Этот курс предназначен для тех, кто хочет научиться <span class='yellow-span '>создавать</span> и&nbsp;<span class='yellow-span '>монетизировать</span> документальное кино.",
        },
      ],
      learnListTop: [
        {
          text: 'Особенности специфики создания документального кино',
          image: ArrowRight,
        },
        {
          text: 'Технологию и структуру просчета бюджета',
          image: ArrowRight,
        },
        {
          text: 'Как планировать КПП',
          image: ArrowRight,
        },
      ],
      learnListTop2: [
        {
          text: 'Как выстраивать коммуникации с заказчиком и контрагентами',
          image: ArrowRight,
        },
        {
          text: 'Специфику работы со сценарием  и творческой группой',
          image: ArrowRight,
        },
      ],
      learnListBot: [
        {
          text: 'Возможность побывать на съемках документальных фильмов',
          image: ArrowRight,
        },
        {
          text: 'Практические занятия и встречи офф-лайн с разбором  реальных проектов',
          image: ArrowRight,
        },
      ],
      learnListBot2: [
        {
          text: 'Индивидуальные консультации и менторинг от мастера курса',
          image: ArrowRight,
        },
        {
          text: 'Возможность участия в проектах FREE SUN PRODUCTION - программа “ЗОЛОТОЙ БОНУС”',
          image: ArrowRight,
        },
      ],

      schemeList: [
        {
          title: '1. Введение. Подготовительный период',
          points: [
            '• Общие сведения об особенностях создания документальных фильмов',
            '• Разработка креативной концепции',
            '• Написание сценария',
            '• Подсчет сметы: основные статьи затрат и ставки',
            '• Защита постановочного проекта у заказчика',
            '• Подбор команды и договоренности о ставках / бюджетов на департамент, коммуникация с подрядчиками',
          ],
        },
        {
          title: '2. Этапы  подготовительного периода документальных фильмов',
          points: [
            '• Подбор героев и коммуникация с ними: важность подробной подготовки их к съемкам',
            '• Разработка КПП и планирование съемок, актуализация сметы',
          ],
        },
        {
          title:
            '3. Финансово-производственные особенности документальных фильмов',
          points: [
            '• КПП и его особенности',
            '• Планирование съемочных смен: почему важно сначала снимать блоки с интервью героев, а после - все остальные сцены',
            '• Как избежать кассового разрыва на этапе планирования',
            '• Как стоит планировать работу с героями',
          ],
        },
        {
          title: '4. Работа с реальной сметой кейса на конкретном примере',
          points: [
            '• Учет не свойственных обычному производству затрат',
            '• Разбор ошибок в смете',
            '• Оптимизация затрат',
            '• Сравнение плановой и фактической сметы',
            '• Итоговое задание блока: посчитать по сценарной заявке смету проекта. Разберем эти сметы в индивидуальном порядке с каждым студентом на онлайн-звонке',
          ],
        },
        {
          title:
            '5. Основные аспекты, которые необходимо учесть на съемочной площадке документального фильма',
          points: [
            '• Вызывной лист документалки',
            '• Придерживание плана, но готовность быстрой перестройки в случае необходимости',
            '• Административная деятельность на площадке',
            '• Работа с опер цехом: особенности выбора и логистики оборудования',
            '• Работа в экспедиции на площадке',
          ],
        },
        {
          title: '6. Практическое занятие №2: разработка вызывного листа',
          points: [
            '• Составление вызывного на реальную смену',
            '• Оповещение группы',
          ],
        },
        {
          title:
            '7.  Практическое занятие №3: присутствие на съемочной площадк',
          points: [
            '• Возможность попробовать себя в продюсерском департаменте на площадке',
            '• Получение опыта на реальной площадке',
          ],
        },
        {
          title:
            '8. Практическое занятие №4: реализация выплат съемочной группе по результатам съемочного периода',
          points: [
            '• Посчитаем фактические затраты по результатам съемок',
            '• Распределим бюджет и осуществим выплаты',
            '• Итоговое задание блока: проявить себя в качестве участника группы в продюсерском департаменте во время съемок',
          ],
        },
        {
          title:
            '9. Последовательность процессов постпродакшена в документальных фильмах',
          points: [
            '• Что такое сборка рыбы и почему она так важна в доке',
            '• Почему в процессе монтажа может меняться и переписываться сценарий и назначаться досъемы',
            '• Технические характеристики процесса',
            '• Цепочка передачи материалов заказчику на утверждение',
            '• Команда поста:',
            '&nbsp;&nbsp;- Монтажер (технические сборки),',
            '&nbsp;&nbsp;- Расшифровщик,',
            '&nbsp;&nbsp;- Редактор и креатив,',
            '&nbsp;&nbsp;- Режиссер монтажа,',
            '&nbsp;&nbsp;- Саудизайнер и Звукорежиссер + Композитор,',
            '&nbsp;&nbsp;- Колорист ',
          ],
        },
        {
          title: '10. Практика №5: присутствие при смысловом монтаже',
          points: [
            '• Побываем в монтажной комнате при работе режиссера монтажа и редактора',
            '• Понаблюдаем за работой расшифровщика',
          ],
        },
        {
          title: '11. Практика №6: разбор правок и комментариев от заказчика',
          points: [
            '• Увидим реальные правки от заказчика к смысловой сборке фильма',
            '• Понаблюдаем за процессом переговоров и внесения правок',
            '• Итоговое задание блока: отсмотреть предмастер-файл фильма и дать комментарии / правки на материал',
          ],
        },
        {
          title: '12. Вручение  дипломов',
          points: ['• Обратная связь от мастера курс'],
        },
      ],
    },
    //производство док кино

    //режиссуоа рекламы (курс в разработке)

    //курс Основы актерского мастерства
    {
      slug: 'THE-COURSE-FUNDAMENTALS-OF-ACTING',
      name: "ОСНОВЫ <span class='yellow-span '><br/>АКТЕРСКОГО МАСТЕРСТВА</span>",
      txt: 'info',
      src: CreativePhotographyImg,
      alt: 'Основы Актерского Мастерства',
      nameTutor: 'АНДРЕЙ ФИНЯГИН',
      courseInfo: [
        {
          name: 'Андрей Финягин',
          value: '15-20 студентов',
          hourse: '24',
          term: 'Срок обучения:',
          deadlines: '4 месяца',
          start: 'весна 2025',
          set: 'Набор курса:',
          set1: 'Открыт',
          shape: 'Формат обучения:',
          price: '100 000 руб.',
          print: '/',
          priceoff: '120 000руб.',
          pricing: 'Стоимость курса:',
          info: 'онлайн и оффлайн',
          exam: 'Вступительные экзамены:',
          interview: 'собеседование',
          helpTutor: 'Поддержка тьютора',
          certificate: 'После прохождения курса выдается сертификат',
        },
      ],
      bgHeader: CreativePhotographyImg,
      bg: jakob,
      bgCourse: Shadow,
      tutorInfo: [
        {
          text: 'Андрей Финягин — актер театра и кино, педагог .Выпускник Школы-студии при МХАТ им. А.П. Чехова (курс О.Н. Ефремова). В разные годы служил в МХАТе им. Чехова, Московском театре юного зрителя, Школе драматического искусства, а также участвовал в независимых театральных проектах. На его счету более 70 ролей в кино и телепроектах. Лауреат фестиваля «Островский-ФЕСТ» в номинации «Лучшая мужская роль» за моноспектакль «Иностранец», почетный деятель искусств города Москвы.',
          quote:
            '«Главное качество, которым должен обладать артист для достижения успеха, — это вера в свою индивидуальность и уникальность, а также обладание внутренней и внешней свободой, которые позволят ему максимально раскрыть и проявить себя».',
          imgTutor: Finygin,
        },
      ],
      quotes:
        "Сыграй свою лучшую роль вместе с <span class='yellow-span'>FREE SUN FILM SCHOOL</span>",
      quotesTitle: 'Ты в фокусе кино!',
      data: "Курс предоставляет <span class='yellow-span'>уникальную возможность</span> овладеть ключевыми навыками <span class='yellow-span'>актерского мастерства</span> и получить возможность работы в проектах FREE SUN PRODUCTION и других кинокомпаний",
      dream: [
        {
          textTitle: 'ЕСЛИ ТЫ ВСЕГДА МЕЧТАЛ',
          text1:
            "оказаться на съемочной площадке и получить роль в кино, но чувствуешь недостаток профессионализма — <span class='yellow-span '>этот курс поможет раскрыть твой потенциал</span> ",
          text2:
            " развитие ключевых актерских навыков, включая внутреннюю и внешнюю свободу, способность к импровизации, работу с голосом, речью <br> и художественным текстом. Курс ориентирован на начинающих актеров <br /> и профессионалов, стремящихся <span class='yellow-span' >повысить свою квалификацию</span> <br> и <span class='yellow-span' >перейти на новый уровень</span> в кино.",
        },
      ],
      learnListTop: [
        {
          text: 'Основы актерской профессии',
          image: ArrowRight,
        },
        {
          text: 'Техники создания характерных ролей',
          image: ArrowRight,
        },
        {
          text: 'Основы сценической речи и техник дыхания',
          image: ArrowRight,
        },
      ],
      learnListTop2: [
        {
          text: 'Принципы актерского существования в кино',
          image: ArrowRight,
        },
        {
          text: 'Правила создания актерской видеовизитки ',
          image: ArrowRight,
        },
        {
          text: 'Искусство актерской импровизации',
          image: ArrowRight,
        },
      ],
      learnListBot: [
        {
          text: 'Опыт работы перед камерой',
          image: ArrowRight,
        },
        {
          text: 'Персональные консультации и менторинг от мастера курса  Андрея Финягина',
          image: ArrowRight,
        },
      ],
      learnListBot2: [
        {
          text: 'Возможность участия в проектах FREE SUN PRODUCTION',
          image: ArrowRight,
        },
        {
          text: '“ЗОЛОТОЙ БОНУС” - уникальный шанс получить продвижение в киноиндустрию',
          image: ArrowRight,
        },
      ],

      schemeList: [
        {
          title: '1. Основы актерской профессии',
          points: [
            '• Введение в актерское мастерство',
            '• Самопрезентация: рассказ о себе',
          ],
        },
        {
          title: '2. Актер (“Я”) в предлагаемых обстоятельствах',
          points: ['• Одиночный этюд: работа в предлагаемых обстоятельствах'],
        },
        {
          title: '3. Конфликт как основа драматургии',
          points: [
            '• Парные этюды на тему конфликта',
            '• Подготовка монолога из драматического произведения',
          ],
        },
        {
          title: '4. Характерные роли в актерской практике',
          points: ['• Одиночные этюды наблюдения за характерными типажами'],
        },
        {
          title: '5. Основы сценической речи',
          points: [
            '• Работа с речевыми скороговорками, техника дыхания, упражнение с пробкой',
            '• Подготовка и отработка скороговорок',
          ],
        },
        {
          title: '6. Поэтическое художественное слово',
          points: ['• Подготовка и исполнение стихотворения'],
        },
        {
          title: '7. Актерская работа в кино',
          points: [
            '• Особенности актерского существования перед камерой',
            '• Подготовка одиночной сцены из фильма',
          ],
        },
        {
          title: '8. Кинопробы и подготовка к ним',
          points: [
            '• Типичные ошибки на пробах, взаимодействие с режиссером, внешний вид',
            '• Подготовка самопрезентации для режиссера',
          ],
        },
        {
          title: '9. Импровизация актера на сцене и в кадре',
          points: ['• Подготовка сцены для кинопроб'],
        },
        {
          title: '10 - 11. Анализ выполненных работ',
          points: [
            '• Просмотр и разбор подготовленных сцен',
            '• Детальный анализ и обсуждение выполненных заданий',
          ],
        },
        {
          title: '12. Итоговая',
          points: [
            '• Обратная связь от мастера курса о росте и развитии каждого студента',
            '• Вручение дипломов',
          ],
        },
      ],
    },

    // курс основы сценарного мастерства
    {
      slug: 'thebasicsofscreenwriting',
      name: "ОСНОВЫ <span class='yellow-span '><br/>СЦЕНАРНОГО МАСТЕРСТВА</span>",
      txt: 'info',
      src: ScreenwritingSkills,
      alt: 'Основы Сценарного Мастерства',
      nameTutor: 'АНДРЕЙ ЩЕРБИНИН',
      courseInfo: [
        {
          name: 'Андрей Щербинин',
          value: '15-20 студентов',
          hourse: '24',
          term: 'Срок обучения:',
          deadlines: '4 месяца',
          start: 'весна 2025',
          set: 'Набор курса:',
          set1: 'Открыт',
          price: '100 000 руб.',
          print: '/',
          priceoff: '120 000руб.',
          pricing: 'Стоимость курса:',
          shape: 'Формат обучения:',
          info: 'онлайн',
          exam: 'Вступительные экзамены:',
          interview: 'собеседование',
          helpTutor: 'Поддержка тьютора',
          certificate: 'После прохождения курса выдается сертификат',
        },
      ],
      bgHeader: ScreenwritingSkillsTop,
      bg: ScreenwritingSkillsBot,
      bgCourse: Shadow,
      tutorInfo: [
        {
          text: 'Андрей Щербинин — драматург и режиссер. Выпускник Киргизского государственного института кино и телевидения, а также Высших курсов сценаристов и режиссеров под руководством Петра Тодоровского. В его профессиональном портфолио — более 60 проектов, включая сценарии для сериалов, книг и фильмов, многие из которых удостоены престижных наград. Щербинин обладает опытом во всех ключевых областях кинопроизводства: от написания сценариев до режиссуры и продюсирования.',
          quote:
            '«Мне 50 лет, и 30 из них я в мире кино. Писательство для меня — это&nbsp;волшебство, где слова оживают и создают новые миры. Я наблюдатель и&nbsp;проводник между реальностью и фантазией».',
          imgTutor: Sherbinin,
        },
      ],
      quotes: ' — будь в фокусе кино! Твои&nbspистории могут изменить мир!',
      quotesTitle: "<span class='yellow-span'>FREE SUN FILM SCHOOL</span>",
      data: " Этот курс разработан мастером, который сочетает <span class='yellow-span'>опыт сценариста и режиссера</span>, передавая знания и практические инструменты, чтобы <span class='yellow-span'>твои идеи воплотились</span> на экране с профессиональной точностью",
      dream: [
        {
          textTitle: 'ЕСЛИ ТЫ МЕЧТАЕШЬ',
          text1:
            "создавать <span class='yellow-span '>сценарии</span>, но теряешься в поисках начала, если вдохновение ускользает, а история не складывается, наш курс поможет обрести уверенность, научит формировать и <span class='yellow-span '>воплощать идеи</span>, превращая их в сюжеты, которые захватят сердца зрителейю",
          text2:
            "вооружить тебя инструментами для создания уникальных сценариев от идеи до полноценной истории, которая захватит зрителя и останется с ним надолго<span class='yellow-span' ></span>.",
        },
      ],
      learnListTop: [
        {
          text: 'Где искать и как формулировать  идеи: логлайн, заявка, синопсис,тритмент',
          image: ArrowRight,
        },
        {
          text: 'Как создавать яркие сцены и эпизоды',
          image: ArrowRight,
        },
        {
          text: 'Структуру сценария: экспозиция, развитие действия, кульминация, финал',
          image: ArrowRight,
        },
        {
          text: 'Конфликты и их виды: внутренние, внешние, межличностные',
          image: ArrowRight,
        },
      ],
      learnListTop2: [
        {
          text: 'Как разрабатывать  персонажа: создание героя и его мотивации',
          image: ArrowRight,
        },
        {
          text: 'Законы жанра и их смешение',
          image: ArrowRight,
        },
        {
          text: 'Как создавать драматическое действие и альтернативные подходы к повествованию',
          image: ArrowRight,
        },
        {
          text: 'Как разработать  выразительные образы и символы  в сценарии',
          image: ArrowRight,
        },
      ],

      learnListBot: [
        {
          text: 'Практический опыт написания сценариев',
          image: ArrowRight,
        },
        {
          text: 'Консультации и менторинг от Андрея Щербинина',
          image: ArrowRight,
        },
      ],
      learnListBot2: [
        {
          text: 'Портфолио с готовыми проектами',
          image: ArrowRight,
        },
        {
          text: 'Возможность участия в проектах FREE SUN PRODUCTION – “ЗОЛОТОЙ БОНУС”',
          image: ArrowRight,
        },
      ],
      schemeList: [
        {
          title: '1. Поиск и формирование идеи',
          points: [
            '• Логлайн, заявка, синопсис: как разработать и эффективно презентовать идею',
          ],
        },
        {
          title: '2. Сюжет и фабула',
          points: [
            '• Расширенный синопсис',
            '• Тритмент: между концепцией и сценарием',
          ],
        },
        {
          title: '3. Сцена и эпизод',
          points: [
            '• Создание ярких, запоминающихся сцен и динамичных эпизодов',
          ],
        },
        {
          title: '4. Структура сценария',
          points: [
            '• Экспозиция, провокация героя , развитие действия, кульминация и финал',
          ],
        },
        {
          title: '5. Конфликт и его виды',
          points: [
            '• Конфликт как движущая сила сюжета: динамика и темпоритм фильма',
          ],
        },
        {
          title: '6. Герой и типы героев',
          points: ['• Цели героя и их взаимодействие с кульминацией фильма'],
        },
        {
          title: '7. Драматическое действие',
          points: [
            '• Цель героя и альтернативные сценарные решения',
            '• Образ и символизм в повествовании',
          ],
        },
        {
          title: '8. Основы операторского мастерства',
          points: ['• Важные визуальные навыки для сценариста'],
        },
        {
          title: '9. Основы монтажа',
          points: ['• Управление временем и ритмом через сценарный монтаж'],
        },
        {
          title: '10. Основы актерского мастерства',
          points: [
            '• Понимание актерской работы как ключ к созданию живых персонажей',
          ],
        },
        {
          title: '11. Основы продюсирования и авторское право',
          points: [
            '• Защита авторских прав и ведение переговоров с продюсерами',
          ],
        },
        {
          title: '12. Итоговое',
          points: [
            '• Обсуждение дипломных работ',
            '• Обратная связь от мастера курса.Вручение дипломов',
          ],
        },
      ],
    },
    //курс в разработке
    {
      slug: 'DocumentaryFilms',
      txt: 'info',
      src: Clip,
      alt: 'Режиссура рекламы  (данный курс в разработке)',
    },

    //курс история кино братьв Люмьер
    {
      slug: 'thehistoryofcinema.',
      name: "<span class='yellow-span '>ИСТОРИЯ КИНО</span><br> ОТ БРАТЬЕВ ЛЮМЬЕР <br>ДО XXI ВЕКА",
      txt: 'info',
      src: HistoryFilm,
      alt: 'История кино от братьев Люмьер до XXI века',
      nameTutor: 'ОЛЕГ ГРОЗНОВ',
      courseInfo: [
        {
          name: 'Олег Грознов',
          value: 'со всех потоков',
          hourse: '24',
          start: 'весна 2025',
          shape: 'Формат обучения:',
          info: 'онлайн и оффлайн',
          exam: 'Вступительные экзамены:',
          interview: 'собеседование',
          helpTutor: 'Поддержка тьютора',
          certificate: 'После прохождения курса выдается сертификат',
          pricing: 'Стоимость курса:',
          price: 'входит в стоимость выбраного вами курса',
        },
      ],
      bgHeader: HistoryFilmTop,
      bg: HistoryFilmBot,
      bgCourse: Shadow,
      tutorInfo: [
        {
          text: 'Олег Грознов — специалист в области истории искусства и преподаватель с многолетним опытом. Окончил Московский городской педагогический университет по специальности «История», затем продолжил обучение в МГУ имени М.В. Ломоносова, где получил диплом по специальности «Историк искусства». В течение своей карьеры работал сценаристом на телеканале «Культура» и накопил более 12 лет опыта в преподавании. Олег Грознов является лауреатом конкурса молодых лекторов «Первая кафедра» и обладателем множества почетных грамот от органов местного самоуправления Москвы. Автор книги «История кино. 24 кадра в секунду. От целлулоида до цифры». Он также является частым экспертом на радио («Маяк», «Радио России») и телевидении (Первый канал, ТВЦ, ОТР).',
          quote:
            '«История кино позволяет нам увидеть, как художественные приемы развивались и трансформировались с течением времени, что делает изучение киноискусства увлекательным и важным».',
          imgTutor: Groznov,
        },
      ],
      quotes:
        "Сыграй свою лучшую роль вместе с <span class='yellow-span'>FREE SUN FILM SCHOOL</span>",
      quotesTitle: 'Ты в фокусе кино!',

      data: "Курс предлагает <span class='yellow-span'>уникальное сочетание теории</span> глубокий анализ ключевых этапов <span class='yellow-span'>развития кино и просмотр культовых фильмов</span> ",
      dream: [
        {
          textTitle: 'ЕСЛИ ТЫ ЧУВСТВУЕШЬ',
          text1:
            "« нехватку знаний о киноискусстве и хочешь понять как&nbsp;и&nbsp;почему кино стало таким,  <span class='yellow-span '>мы готовы помочь тебе лучше узнать его историю</span>» ",
          text2:
            " Курс направлен на то, чтобы дать слушателям всестороннее представление о&nbsp;развитии киноязыка — от его зарождения до современности, с особым акцентом на <span class='yellow-span' >выдающихся режиссерах</span>  и их <span class='yellow-span' >фильмографии</span>.",
        },
      ],
      learnListTop: [
        {
          text: 'Основные этапы развития киноискусства',
          image: ArrowRight,
        },
        {
          text: 'Вклад ключевых режиссеров в кинематограф',
          image: ArrowRight,
        },
      ],
      learnListTop2: [
        {
          text: 'Технологические и индустриальные изменения в кино',
          image: ArrowRight,
        },
        {
          text: 'Значимые художественные направления и течения',
          image: ArrowRight,
        },
      ],
      learnListBot: [
        {
          text: 'Глубокие теоретические знания по истории кино',
          image: ArrowRight,
        },
        {
          text: 'Практический опыт анализа и интерпретации фильмов',
          image: ArrowRight,
        },
      ],
      learnListBot2: [
        {
          text: 'Консультации и менторинг от эксперта',
          image: ArrowRight,
        },
        {
          text: 'Участие в профессиональном сообществе и киноклубе',
          image: ArrowRight,
        },
      ],

      schemeList: [
        {
          title: '1. 1890-1910. Зарождение и первые годы развития кино',
        },
        {
          title: '2. 1910-1930. Период великого немого',
        },
        {
          title:
            '3. 930-1940. Рождение звукового кино. Приход цвета. Поэтический реализм. Соцреализм. Третий рейх',
        },
        {
          title: '4. 1940-1950. Неореализм. Нуар. Орсон Уэллс',
        },
        {
          title:
            '5. 1950-1960. Конец Золотого века Голливуда. Хичкок. Открытие Японии. Папино кино во Франции',
        },
        {
          title: '6. 1960-1980. Часть 1. Новая волна. Кино Италии',
        },
        {
          title: '7. 1960-1980. Часть 2. Новый Голливуд',
        },
        {
          title: '8. 1960-1980. Кино «оттепели», «новые волны». Тарковский',
        },
        {
          title: '9. 1980-2000. Постмодернизм: США',
        },
        {
          title: '10. 1980-2000. Постмодернизм: Европа',
        },
        {
          title: '11. XXI век',
        },
        {
          title: '12. Итоговая',
          points: [
            '• Обратная связь от мастера курса после результатов итогового тестирования',
            '• Вручение сертификатов',
          ],
        },
      ],
    },

    //курс Киноклуб
    {
      slug: 'kinoclub',
      name: "<span class='yellow-span '>КИНОКЛУБ</span>",
      txt: 'info',
      src: CinemaClub,
      alt: 'Киноклуб',
      nameTutor: 'ОЛЕГ ГРОЗНОВ',
      courseInfo: [
        {
          name: 'Олег Грознов',
          value: 'со всех потоков',
          hourse: '24',
          start: 'весна 2025',
          price: 'входит в стоимость выбраного вами курса',
          pricing: 'Стоимость курса:',
          shape: 'Формат обучения:',
          info: 'онлайн и оффлайн',
          exam: 'Вступительные экзамены:',
          interview: 'собеседование',
          helpTutor: 'Поддержка тьютора',
          certificate: 'После прохождения курса выдается сертификат',
        },
      ],
      bgHeader: CinemaClubTop,
      bg: CinemaClubBot,
      bgCourse: Shadow,
      tutorInfo: [
        {
          text: 'Олег Грознов — признанный специалист в области истории искусства и преподаватель с многолетним опытом. Окончил Московский городской педагогический университет по специальности «История», затем продолжил обучение в МГУ имени М.В. Ломоносова, где получил диплом по специальности «Историк искусства». В течение своей карьеры работал сценаристом на телеканале «Культура» и накопил более 12 лет опыта в преподавании. Олег Грознов является лауреатом конкурса молодых лекторов «Первая кафедра» и обладателем множества почетных грамот от органов местного самоуправления Москвы. Автор книги «История кино. 24 кадра в секунду. От целлулоида до цифры». Он также является частым экспертом на радио («Маяк», «Радио России») и телевидении (Первый канал, ТВЦ, ОТР). ',
          quote:
            '«Кино — это не просто развлечение. Это способ увидеть мир глазами другого человека и научиться читать сложный визуальный текст».',
          imgTutor: Groznov,
        },
      ],
      quotes:
        'это не просто развлечение. Это&nbsp;способ увидеть мир глазами другого человека и научиться читать сложный визуальный текст',
      quotesTitle: "<span class='yellow-span'>FREE SUN FILM SCHOOL</span> — ",
      data: "Курс предназначен для всех, кто хочет научиться <span class='yellow-span'>понимать кино</span>  на более глубоком уровне. Вы научитесь анализировать визуальные решения, монтажные ходы, звукоряд и драматургию,чтобы раскрыть <span class='yellow-span'>все грани смысла</span>  фильма",
      dream: [
        {
          textTitle: 'ЕСЛИ ТЫ КОГДА-ЛИБО',
          text1:
            "чувствовал, что пропускаешь важные детали в фильмах или не можешь понять, почему они оказывают такое сильное влияние, мы покажем тебе все тайны киноискусства и <span class='yellow-span '>научим понимать</span>  каждый кадр. ",
          text2:
            "предназначен для всех, кто хочет научиться понимать кино на&nbsp;более <span class='yellow-span' >глубоком уровне</span>. Вы&nbsp;научитесь анализировать визуальные решения, монтажные ходы, звукоряд и&nbsp;драматургию, чтобы раскрыть все <span class='yellow-span' >грани смысла</span> фильма.",
        },
      ],
      learnListTop: [
        {
          text: 'Как анализировать композицию кадра и цветовую гамму',
          image: ArrowRight,
        },
        {
          text: 'Техники игры света и тени',
          image: ArrowRight,
        },
      ],
      learnListTop2: [
        {
          text: 'Основы операторских приемов и роль монтажа',
          image: ArrowRight,
        },
        {
          text: 'Как следить за развитием повествования и драматургией',
          image: ArrowRight,
        },
      ],
      learnListBot: [
        {
          text: 'Глубокое понимание кино как сложного визуального текста',
          image: ArrowRight,
        },
        {
          text: 'Навыки критического анализа фильмов',
          image: ArrowRight,
        },
      ],
      learnListBot2: [
        {
          text: 'Возможность участвовать в обсуждениях и делиться своими впечатлениями',
          image: ArrowRight,
        },
        {
          text: 'Доступ к эксклюзивным материалам и рекомендациям от Олега Грознова',
          image: ArrowRight,
        },
      ],

      schemeList: [
        {
          title: '1. Введение в киноведение: основы анализа визуальных текстов',
        },
        {
          title:
            '2. Разбор классических фильмов: Чарли Чаплин «Золотая лихорадка», Орсон Уэллс «Гражданин Кейн»',
        },
        {
          title:
            '3. Анализ современных шедевров: Паоло Соррентино «Великая красота», Пон Чжун Хо «Паразиты»',
        },
        {
          title:
            '4. Работа со светом и тенью: Ингмар Бергман «Шепоты и крики», Ларс фон Триер «Догвилль»',
        },
        {
          title:
            '5. Техники монтажа: Квентин Тарантино «Криминальное чтиво», Пол Верховен «Турецкие наслаждения»',
        },
        {
          title:
            '6. Звуковой дизайн и музыкальное сопровождение: Вуди Аллен «Матч-пойнт», Педро Альмодовар «Свяжи меня»',
        },
        {
          title:
            '7. Драматургия и развитие повествования: Акира Куросава «Расемон», Сергей Эйзенштейн «Броненосец Потемкин»',
        },
      ],
    },
    //курс в разработке
    {
      slug: 'DocumentaryFilms',
      txt: 'info',
      src: Orator,
      alt: 'Ораторское мастерство (данный курс в разработке)',
    },
  ],
}
